export default "__VITE_ASSET__DRsEfpqA__"